import React from "react";
import { motion } from "framer-motion";
import MickeyEars from "./MickeyEars";

const scrollTo = (id) => {
    const el = document.getElementById(id);
    if (el) el.scrollIntoView({ behavior: "smooth", block: "start" });
};

export const Hero = () => {
    return (
        <section
            data-testid="hero-section"
            className="relative overflow-hidden polka pt-10 pb-20 sm:pt-16 sm:pb-28"
        >
            {/* Decorative floating shapes */}
            <div className="absolute -top-6 -left-6 sm:top-10 sm:left-10 float-slow opacity-90 pointer-events-none">
                <MickeyEars size={80} color="#111" />
            </div>
            <div className="absolute top-24 right-6 sm:right-16 float-slower pointer-events-none">
                <div className="w-14 h-14 sm:w-20 sm:h-20 rounded-full bg-secondary border-thick shadow-pop-sm" />
            </div>
            <div className="absolute bottom-12 left-10 sm:left-24 float-slow pointer-events-none">
                <div className="w-12 h-12 sm:w-16 sm:h-16 rounded-full bg-primary border-thick shadow-pop-sm" />
            </div>

            <div className="max-w-6xl mx-auto px-6 grid lg:grid-cols-2 gap-12 items-center relative z-10">
                {/* Left: Typography */}
                <div className="text-left">
                    <motion.h1
                        initial={{ opacity: 0, y: 30 }}
                        animate={{ opacity: 1, y: 0 }}
                        transition={{ duration: 0.6, delay: 0.1 }}
                        className="font-heading text-5xl sm:text-7xl lg:text-8xl font-bold leading-[0.95]"
                    >
                        Christopher{" "}
                        <span className="inline-block bg-primary text-primary-foreground px-3 py-1 rounded-2xl border-thick shadow-pop-sm rotate-[-2deg]">
                            faz 2
                        </span>{" "}
                        <br />
                        aninhos!
                    </motion.h1>

                    <motion.p
                        initial={{ opacity: 0 }}
                        animate={{ opacity: 1 }}
                        transition={{ duration: 0.6, delay: 0.3 }}
                        className="mt-6 text-lg sm:text-xl max-w-lg text-foreground/80"
                    >
                        O Christopher está fazendo 2 aninhos e a festa vai ser
                        do Mickey! Vai rolar brincadeira, bolo e muita
                        diversão. Vem comemorar com a gente?
                    </motion.p>

                    <motion.div
                        initial={{ opacity: 0, y: 20 }}
                        animate={{ opacity: 1, y: 0 }}
                        transition={{ duration: 0.6, delay: 0.45 }}
                        className="mt-8 flex flex-wrap gap-4"
                    >
                        <button
                            data-testid="hero-rsvp-btn"
                            onClick={() => scrollTo("rsvp")}
                            className="font-heading text-lg sm:text-xl bg-primary text-primary-foreground border-thick rounded-full px-7 py-3 shadow-pop hover:-translate-y-1 hover:translate-x-[-1px] transition-transform active:translate-y-0"
                        >
                            Confirmar Presença
                        </button>
                        <button
                            data-testid="hero-details-btn"
                            onClick={() => scrollTo("event-details")}
                            className="font-heading text-lg sm:text-xl bg-white text-foreground border-thick rounded-full px-7 py-3 shadow-pop hover:-translate-y-1 hover:translate-x-[-1px] transition-transform active:translate-y-0"
                        >
                            Detalhes do Evento
                        </button>
                    </motion.div>

                    <motion.div
                        initial={{ opacity: 0 }}
                        animate={{ opacity: 1 }}
                        transition={{ delay: 0.6 }}
                        className="mt-10 flex flex-wrap gap-6 text-sm font-heading uppercase tracking-widest"
                    >
                        <div data-testid="hero-date">
                            <span className="text-foreground/60 mr-2">Data</span>
                            <span className="bg-secondary text-secondary-foreground border-thick rounded-full px-3 py-1">
                                12 de Julho
                            </span>
                        </div>
                        <div data-testid="hero-time">
                            <span className="text-foreground/60 mr-2">Hora</span>
                            <span className="bg-secondary text-secondary-foreground border-thick rounded-full px-3 py-1">
                                1:30 PM
                            </span>
                        </div>
                    </motion.div>
                </div>

                {/* Right: Visual */}
                <motion.div
                    initial={{ opacity: 0, scale: 0.92, rotate: -2 }}
                    animate={{ opacity: 1, scale: 1, rotate: 0 }}
                    transition={{ duration: 0.7, delay: 0.2 }}
                    className="relative"
                >
                    <div className="relative border-thick rounded-[48px] overflow-hidden shadow-pop-lg bg-secondary aspect-[4/5] max-w-md mx-auto">
                        <img
                            src="https://images.unsplash.com/photo-1759330203240-b89ccee8840f?crop=entropy&cs=srgb&fm=jpg&q=85&w=900"
                            alt="Playground colorido para festa do Mickey"
                            className="w-full h-full object-cover"
                            loading="eager"
                        />
                        <div className="absolute top-4 left-4 bg-primary text-primary-foreground font-heading text-xs uppercase tracking-widest border-thick rounded-full px-3 py-1 shadow-pop-sm">
                            Oh boy!
                        </div>
                    </div>
                    {/* Floating sticker */}
                    <div className="absolute -bottom-6 -left-4 sm:-left-8 bg-white border-thick rounded-3xl px-5 py-4 shadow-pop rotate-[-6deg]">
                        <div className="flex items-center gap-3">
                            <MickeyEars size={36} />
                            <div>
                                <p className="font-heading text-sm uppercase tracking-widest text-foreground/60">
                                    Onde
                                </p>
                                <p className="font-heading text-base sm:text-lg font-bold leading-tight">
                                    Tree House Indoor Play
                                </p>
                            </div>
                        </div>
                    </div>
                </motion.div>
            </div>
        </section>
    );
};

export default Hero;
